




















import { Component, Inject, Mixins } from 'vue-property-decorator';
import { DeferredMixin, RouteParsedMixin } from '../../mixins';
import { SimpleCard as Card } from '../../blocks';
import { Warning, Header, ListGrid } from '../../components';
import { HistoryItems, IHistory, EventVisitHistoryRepo } from './types';
import { routeParse } from '@/pages/profile/utils';

@Component({
  components: {
    Header,
    ListGrid,
    Card,
    Warning,
  },
  metaInfo: () => ({
    title: 'История просмотров',
  }),
})
export default class History
  extends Mixins(DeferredMixin, RouteParsedMixin)
  implements IHistory
{
  @Inject() $eventVisitHistory: any;

  history: HistoryItems = [];

  // Computed
  get hasItems() {
    const { history } = this;
    return history && history.length > 0;
  }

  mounted() {
    this.history = this.$eventVisitHistory.load().reverse();
  }

  getActualParse(val: EventVisitHistoryRepo) {
    if (val.isActivity) {
      return this.routerActivity(val);
    } else {
      return this.parse(val);
    }
  }

  routerActivity(val: EventVisitHistoryRepo) {
    const id = val.id;
    const name = 'activity';
    const router = routeParse(id, '', name);
    return router;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/views/history/History.vue